/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Lock_StatusInputs */



/**
* | output |
* | --- |
* | "Lock Status" |
*
* @param {Explorer_Info_Property_Lock_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_lock_status = /** @type {((inputs?: Explorer_Info_Property_Lock_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Lock_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Statut de verrouillage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sperrstatus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato di blocco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Статус блокировки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado de bloqueo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロックステータス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉक स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Status de bloqueio")
	return /** @type {LocalizedString} */ ("Lock Status")
});